import React from 'react';
import '../styles/Loading.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

function Loading() {

    return (
        <div className="loading-container">
            <DotLottieReact
                src="https://lottie.host/7f215b0b-e72e-41ed-b9af-4249c3810a00/afvrLLR4JB.lottie"
                loop
                autoplay
            />
        </div>
    )
}

export default Loading;